export default "__VITE_ASSET__BJyMH7BK__"